/**
 * Transcript Toggle Button
 * 
 * Floating button to open/close the transcript panel
 * Shows unread message count badge when panel is closed
 */

import React from 'react';
import { useTranscript } from '../../contexts/TranscriptContext';
import './transcript-toggle.scss';

export const TranscriptToggle: React.FC = () => {
  const { isPanelOpen, togglePanel, unreadCount } = useTranscript();

  return (
    <button
      className={`transcript-toggle ${isPanelOpen ? 'open' : 'closed'}`}
      onClick={togglePanel}
      aria-label={isPanelOpen ? 'Close transcript' : 'Open transcript'}
      title={isPanelOpen ? 'Close transcript' : 'Open transcript'}
    >
      <span className="material-symbols-outlined toggle-icon">
        {isPanelOpen ? 'close' : 'chat'}
      </span>
      {!isPanelOpen && unreadCount > 0 && (
        <span className="unread-badge">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};
